import React from "react";
import { PropTypes } from "prop-types";
import { Box } from "@mui/material";

const Hidden = ({ hidden, children, ...other }) => {
  return (
    <Box style={{ display: hidden ? "none" : "inherit" }} {...other}>
      {children}
    </Box>
  );
};

export default Hidden;

Hidden.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.node
};
